module.exports = __webpack_public_path__ + "img/db1000.0140dd28.jpg";